import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaWhatsapp,
  FaUsers,
  FaUserTie,
  FaCrown,
  FaIdBadge,
} from "react-icons/fa";
import "./whatsapp.css";
import { getContactLinks } from "../../services/contactApi";
import { toast } from "react-toastify";
import { useEffect } from "react";
// import { getWhatsAppLink } from "../services/whatsappService";

const OPTIONS = {
  forid: {
    type: "id",
    label: "For ID",
    icon: <FaIdBadge />,
    number: "+919787655918",
    message: "Hello, I need an ID",
  },
  customer: {
    type: "customer",
    label: "Customer",
    icon: <FaUsers />,
    number: "+919787655918",
    message: "Hello, customer support",
  },
  affliate: {
    type: "affiliate",
    label: "Affiliate",
    icon: <FaUserTie />,
    number: "+919787655918",
    message: "Hello, affiliate enquiry",
  },
  vip: {
    type: "vip",
    label: "VIP",
    icon: <FaCrown />,
    number: "+919787655918",
    message: "Hello, VIP support",
  },
};

export const WhatsAppFloating = () => {
  const [open, setOpen] = useState(false);
  const [contact, setContact] = useState(null);

  const handleClick = async (number, message) => {
    window.open(
      `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  const fetchContacts = async () => {
    try {
      const res = await getContactLinks();
      if (res?.data) {
        setContact(res.data);
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  useEffect(() => {
    fetchContacts();
  }, []);

  const options = contact
    ? Object.keys(OPTIONS).map((key) => {
        console.log("key", key, contact[key]);
        return {
          ...OPTIONS[key],
          type: key,
          number: contact[key],
        };
      })
    : [];

  return (
    <div
      className="wa-wrapper"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {" "}
      <AnimatePresence>
        {open && (
          <motion.div
            className="wa-options"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
          >
            {options?.map((o, i) => (
              <motion.button
                key={o.type}
                className={`wa-option ${o.type}`}
                onClick={() => handleClick(o.number, o.message)}
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.07 }}
                whileHover={{ scale: 1.1 }}
              >
                {o.icon}
                <span>{o.label}</span>
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <motion.div className="wa-main" whileHover={{ scale: 1.1, rotate: 360 }}>
        <FaWhatsapp />
      </motion.div>
    </div>
  );
};
